import React from 'react';

const InstructorComp1 = ({ instructorData = {} }) => {
  const hasInstructor = instructorData && Object.keys(instructorData).length > 0;
  const instructorName = hasInstructor ? instructorData.name : 'No tutor assigned yet';
  const instructorImage = hasInstructor && instructorData.image ? instructorData.image : null;
  
  return (
    <div className="inline-flex justify-start items-center gap-2">
      {instructorImage ? (
        <img 
          src={instructorImage} 
          alt={instructorName}
          className="w-20 h-20 rounded-full object-cover" 
        />
      ) : (
        <div className="w-20 h-20 rounded-full bg-gray-200" />
      )}
      <div className={`justify-center text-base font-['Arial'] leading-normal ${hasInstructor ? 'text-neutral-900 font-bold' : 'text-gray-500 font-normal'}`}>
        {instructorName}
      </div>
    </div>
  );
};

export default InstructorComp1;